// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import * as Tailwind$LiteracyplanetTupperware from "./Tailwind.res.mjs";
import * as V3ClozeDndStyleContext$LiteracyplanetTupperware from "./V3ClozeDndStyleContext.res.mjs";

function PilotClozeDropBucketDisplay(props) {
  var children = props.children;
  var dndStyle = Curry._1(V3ClozeDndStyleContext$LiteracyplanetTupperware.use, undefined);
  if (dndStyle === "Bucket") {
    return React.createElement("div", {
                className: TailwindMerge.twMerge("grid", "gap-5", Tailwind$LiteracyplanetTupperware.makeGridCols(props.numColumns))
              }, children);
  } else {
    return React.createElement("div", {
                className: "pilotClozeChainDisplay"
              }, children);
  }
}

var make = PilotClozeDropBucketDisplay;

var $$default = PilotClozeDropBucketDisplay;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
